// Variant Thumbnails Functionality
function changeMainImage(newImageUrl, thumbnailElement) {
    // Find the main product image in the same card
    const card = thumbnailElement.closest('.card-wrapper');
    
    // Find ALL images in the media container (main image and hover image)
    const allImages = card.querySelectorAll('.card__media .media img');
    
    if (allImages.length > 0) {
      // Update all images in the media container to the SAME image
      allImages.forEach((image, index) => {
        // Force image reload by removing and re-adding loading attribute
        const originalLoading = image.getAttribute('loading');
        image.removeAttribute('loading');
        
        // Change the image source - ALL images get the SAME URL
        image.src = newImageUrl;
        
        // Update srcset for responsive images
        const baseUrl = newImageUrl.split('?')[0];
        const newSrcset = [
          `${baseUrl}?width=165 165w`,
          `${baseUrl}?width=360 360w`,
          `${baseUrl}?width=533 533w`,
          `${baseUrl}?width=720 720w`,
          `${baseUrl}?width=940 940w`,
          `${baseUrl}?width=1066 1066w`
        ].join(', ');
        
        image.srcset = newSrcset;
        
        // Force browser to reload the image
        image.style.opacity = '0.5';
        
        // Wait for image to load, then restore opacity and loading attribute
        image.onload = function() {
          image.style.opacity = '1';
          if (originalLoading) {
            image.setAttribute('loading', originalLoading);
          }
        };
        
        // Fallback: restore opacity after 500ms even if onload doesn't fire
        setTimeout(() => {
          image.style.opacity = '1';
          if (originalLoading) {
            image.setAttribute('loading', originalLoading);
          }
        }, 500);
      });
      
      // Update active thumbnail indicators
      updateActiveThumbnail(thumbnailElement);
    } else {
      console.error('No images found! Selector used: .card__media .media img');
      // Try alternative selectors
      const altImage1 = card.querySelector('.card__media img');
      const altImage2 = card.querySelector('.media img');
      const altImage3 = card.querySelector('img');
    }
  }
  
  function updateActiveThumbnail(activeThumbnail) {
    // Find all thumbnails in the same card
    const card = activeThumbnail.closest('.card-wrapper');
    const allThumbnails = card.querySelectorAll('.variant-thumbnails img');
    
    // Reset all thumbnails to inactive state (dotted border)
    allThumbnails.forEach(thumb => {
      thumb.style.borderStyle = 'dotted';
    });
    
    // Set active thumbnail (solid border)
    const activeImg = activeThumbnail.querySelector('img') || activeThumbnail;
    activeImg.style.borderStyle = 'solid';
  }
  
  // Set initial active thumbnail on page load
  document.addEventListener('DOMContentLoaded', function() {
    const cards = document.querySelectorAll('.card-wrapper');
    
    cards.forEach(card => {
      const allImages = card.querySelectorAll('.card__media .media img');
      const thumbnails = card.querySelectorAll('.variant-thumbnails img');
      
      if (allImages.length > 0 && thumbnails.length > 0) {
        const mainImageUrl = allImages[0].src; // Use first image as reference
        let foundMatch = false;
        
        // Find matching thumbnail and mark as active
        thumbnails.forEach(thumbnail => {
          const thumbnailUrl = thumbnail.src;
          const thumbnailBaseUrl = thumbnailUrl.split('?')[0];
          const mainImageBaseUrl = mainImageUrl.split('?')[0];
          
          if (thumbnailBaseUrl === mainImageBaseUrl && !foundMatch) {
            thumbnail.style.borderStyle = 'solid';
            foundMatch = true;
          } else {
            thumbnail.style.borderStyle = 'dotted';
          }
        });
        
        // If no match found, mark first thumbnail as active
        if (!foundMatch && thumbnails.length > 0) {
          thumbnails[0].style.borderStyle = 'solid';
        }
        
        // IMPORTANT: Sync all images to show the same image
        // This ensures that both main and hover image show the same variant
        if (allImages.length > 1) {
          const referenceImageSrc = allImages[0].src;
          const referenceImageSrcset = allImages[0].srcset;
          
          // Set all other images to match the first image
          for (let i = 1; i < allImages.length; i++) {
            allImages[i].src = referenceImageSrc;
            allImages[i].srcset = referenceImageSrcset;
          }
        }
      }
    });
  }); 